import React from "react";
import { PageSection } from "@/components/AppLayout.jsx";
import { DojoOsModulePlaceholder } from "@/coquille-bridge";
import { useI18n } from "@/coquille-bridge";

/**
 * Page placeholder structurée DojoOS — aucune donnée officielle inventée.
 * @param {object} props
 * @param {string} props.moduleId
 * @param {string} [props.testId]
 * @param {string} [props.subtitle]
 */
export function DojoOsPlaceholderPage({ moduleId, testId, subtitle }) {
  const { lang } = useI18n();
  const locale = lang === "en" ? "en" : "fr";
  return (
    <PageSection
      title=""
      subtitle={subtitle}
      testId={testId || `page-dojoos-${moduleId}`}
    >
      <DojoOsModulePlaceholder moduleId={moduleId} locale={locale} testId={`dojoos-ph-${moduleId}`} />
    </PageSection>
  );
}

export function AdminAssistantsPage() {
  return <DojoOsPlaceholderPage moduleId="assistants" testId="page-admin-assistants" />;
}

export function AdminParentsPage() {
  return <DojoOsPlaceholderPage moduleId="parents" testId="page-admin-parents" />;
}

export function AdminCommunicationsPage() {
  return <DojoOsPlaceholderPage moduleId="communications" testId="page-admin-communications" />;
}
